import React, { useState } from 'react';
import '../styles/App.css';
import { HeaderMenu } from './HeaderMenu';
import { SideMenu } from './SideMenu';
import { AuthContext } from '../context/AuthContext';
import { LoginScreen } from './LoginScreen';
import { ContentComponents } from './ContentComponents';
import { BootingScreen } from './BootingScreen';

const MainComponent: React.FC = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(true);
    const authContext = React.useContext(AuthContext);

    if (!authContext) {
        throw new Error('MainComponent must be used within an AuthProvider');
    }
    const { isLoggedIn, initialized } = authContext;
    if (!initialized) {
        return <BootingScreen />;
    }
    if (!isLoggedIn()) {
        return <LoginScreen />;
    }

    const openMenu = () => setIsMenuOpen(true);
    const closeMenu = () => setIsMenuOpen(false);

    return (
        <div className="App">
            {/* <InstallPrompt /> */}
            <HeaderMenu onMenuClick={openMenu} />
            <SideMenu isOpen={isMenuOpen} onClose={closeMenu} />
            <ContentComponents />
        </div>
    );
};

export default MainComponent;